import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import SectionHeading from "./SectionHeading";

export default function TopicsSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <SectionHeading
        eyebrow="专题合集"
        title="主题专题推荐"
        description="围绕投资入门、市场回顾与政策动态，将相关资讯梳理为清晰的专题合集，方便系统阅读。"
        linkTo="/category/investment-news"
        linkLabel="浏览全部专题"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to="/category/investment-news"
            className="group relative rounded-lg overflow-hidden border border-background-200 h-72"
          >
            <img
              src={topic.cover}
              alt={topic.title}
              title={`${topic.title} - 黄金投资专题`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-accent-950 via-accent-950/60 to-accent-950/10" />
            <div className="relative h-full flex flex-col justify-end p-5">
              <span className="text-xs font-label text-primary-300 mb-2">{topic.subtitle}</span>
              <h3 className="font-heading font-bold text-lg text-foreground-50 mb-2">{topic.title}</h3>
              <p className="text-xs text-foreground-200 leading-relaxed line-clamp-2 mb-4">{topic.description}</p>
              <div className="flex items-center justify-between text-xs">
                <span className="text-foreground-300">共 {topic.articleCount} 篇</span>
                <span className="flex items-center gap-1 text-primary-300 group-hover:gap-2 transition-all">
                  进入专题
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}